'use client';

import Cookies from 'js-cookie';
import { useFlags } from 'launchdarkly-react-client-sdk';
import type { SubscribedFlags } from './flags';

/**
 * A wrapper over `useFlags` that supports cookie overrides that uses LDFlagSet
 * (type from LD) to assert the same predictable return
 */
export function useAppFlags<T extends SubscribedFlags>(): T & {
  __loading__: boolean;
} {
  // Get flags from Launch Darkly
  const rawFlags = useFlags<T>();

  let flags: T = rawFlags;
  try {
    // Load flags from cookies for overriding the LD flags manually
    const overrideFlags: T = JSON.parse(Cookies.get('side-ld-flags') || '{}');
    flags = {
      ...rawFlags,
      ...overrideFlags,
    };
  } catch (error) {
    // TODO: [PLAT-1731] use standardized logger module in ui
    // biome-ignore lint/suspicious/noConsole: come back to this
    console.error('Error getting the launchdarkly flags', { error });
  }

  const loading = Object.keys(flags).length === 0;

  return { ...flags, __loading__: loading };
}
